module.exports = __webpack_public_path__ + "img/Frente-12-01 on.3b2f90bb.png";